@if (!hasFiles()) {
  <div class="text-base text-gray-400 border border-dashed border-gray-300 rounded-md flex flex-col items-center justify-center">
    <span class="m-[10px]">{{emptyMessage()}}</span>
  </div>
} @else {
  <div class="relative rounded-md">

    <!-- Gallery Strip -->
    <div #galleryContainer
         class="flex overflow-x-auto w-full gap-1 py-2"
         style="scrollbar-width: none; -ms-overflow-style: none;"
         (scroll)="updateScrollButtons()">
      <lightgallery
        #lightGallery
        [onInit]="onInit"
        [settings]="settings"
        class="flex gap-1">
        @for (file of files(); track file.id) {
          <div class="relative flex-shrink-0 group/item">
            <a
              class="gallery-item block"
              data-lg-size="480-475-480, 800-791-800, 1406-1390"
              [attr.data-src]="environment.fileApi + '/view/' + file.fullPath + '?width=1406'"
              [attr.data-download-url]="environment.fileApi + '/view/' + file.fullPath">
              @if (environment.fileApi) {
                <img class="object-cover rounded-md border border-gray-200 hover:border-gray-300 transition-colors cursor-pointer"
                    [style.width.px]="thumbnailSize()"
                    [style.height.px]="thumbnailSize()"
                    [src]="environment.fileApi + '/view/' + file.fullPath + '?width=200&height=200'"/>
              }
            </a>
            @if (showDeleteButton()) {
              <button
                type="button"
                (click)="deleteFile(file); $event.stopPropagation()"
                class="absolute top-1 right-1 w-6 h-6 flex items-center justify-center bg-white/90 border border-gray-200 rounded-full shadow-sm hover:bg-red-50 hover:border-red-300 transition-colors opacity-0 group-hover/item:opacity-100">
                <i class="relative text-[14px] text-gray-500 hover:text-red-500" [ngClass]="'icon-trash'"></i>
              </button>
            }
          </div>
        }
      </lightgallery>
    </div>

    <!-- Left Gradient Overlay -->
    @if (canScrollLeft()) {
      <div class="absolute left-0 top-0 bottom-0 w-10 bg-gradient-to-r from-white to-transparent pointer-events-none flex items-center justify-start">
        <button
          type="button"
          (click)="scrollLeft()"
          class="pointer-events-auto ml-0.5 text-gray-500 hover:text-gray-800 transition-colors cursor-pointer">
          <i class="relative text-[20px]" [ngClass]="'icon-previous'"></i>
        </button>
      </div>
    }

    <!-- Right Gradient Overlay -->
    @if (canScrollRight()) {
      <div class="absolute right-0 top-0 bottom-0 w-10 bg-gradient-to-l from-white to-transparent pointer-events-none flex items-center justify-end">
        <button
          type="button"
          (click)="scrollRight()"
          class="pointer-events-auto mr-0.5 text-gray-500 hover:text-gray-800 transition-colors cursor-pointer">
          <i class="relative text-[20px]" [ngClass]="'icon-next'"></i>
        </button>
      </div>
    }

  </div>
}
